<script>
import UserLink from '../../components/UserLink.vue';
import TowerLink from '../../components/TowerLink.vue';
import ContentCard from './ContentCard.vue';

export default {
    props: {
        item: Object
    },
    render(h) {
        const item = this.item;
        const { type, on, by, byname, timestamp, ref } = item;
        const user = <UserLink id={by} name={byname}/>;
        const tower = item.towerTitle ? <TowerLink name={on} title={item.towerTitle} /> : null;
        const outer = (inner) => {
            <div>
                { inner }
                <p>{ this.formatDate(timestamp) }</p>
            </div>
        }
        switch(type) {
            case "break": {
                const { score } = item;
                let addon = ""
                if (item.hard) addon += `${item.hard}难度`;
                if (item.ending) addon += `${item.ending}结局`;
                return (
                    <div>
                        { user }在{ tower }{ addon }中以{ score }的成绩夺走了你的榜单
                    </div>
                );
            }
            case "update":
            case "follow": {
                return (
                    <div>
                        {user}关注了你
                    </div>
                );
            }
            case "comment": {
                const { content } = item;
                return (
                    <div>
                        {user}在{tower}的评论区中发言
                        <div class="comment">
                            { content }
                        </div>
                    </div>
                );
            }
            case "comment.reply":
            case "comment.talk": {
                const { content, tocontent } = item;
                return (
                    <div>
                        {user}在{tower}的评论区中回复了你的评论
                        <div class="comment">
                            { content }
                        </div>
                    </div>
                );
            }
            case "post": {
                const { bid, tid, page, content } = item;
                return (
                    <div>
                        {user}回复了你的帖子<a href={`/bbs/thread?bid=${bid}&tid=${tid}&p=1`} target="_blank">{item.title}</a>
                        <div class="comment">
                            { content.length <= 140 ? content : (content.substring(0, 140) + "...") }
                        </div>
                    </div>
                );
            }
            case "post.reply": {
                return (
                    <div>
                        {user}回复了你的帖子
                    </div>
                );
            }
            case "post.talk": {
                return (
                    <div>
                        {user}回复了你的帖子
                    </div>
                );
            }
            case "post.quote": {
                return (
                    <div>
                        {user}引用了你的帖子
                    </div>
                );
            }
        }
        return <div></div>;
    },
    methods: {
        formatDate(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleString("cn-ZH", { hour12: false });
        }
    },
    components: {
        TowerLink,
    }
}
</script>

<style>

</style>